<template lang="html">
  <div class="Intro">
    <div class="lead">
      <h2><strong><span class="highlight">Post, watch and share moments in{{'\xA0'}}long videos</span></strong>: lectures, presentations, reviews, mashups, etc.</h2>
    </div>
    <div class="in-progress">
      <h2>Work in progress </h2>
      <!-- <p>This pre-Beta shows only the core idea. More (adding, voting, playlists, favorites, embeding, etc.) is coming -->
      <p>This pre-Beta shows only the core idea. More (adding, voting, playlists, favorites, embeding, etc.) is coming{{'\xA0'}}— <a href="http://eepurl.com/gRETMT" title="link to subscription form" class="subscribe-link">subscribe</a> to be the first to know when it's finally available</p>
      <p>Please drop your thoughts and questions directly to <a href="mailto:keeper@clipleap.com">keeper@clipleap.com</a></p>
      <!-- <p>Please share your thoughts and questions on it in <a href="#">this Reddit post</a>, ProductHunt or drop them directly to <a href="mailto:keeper@clipleap.com">keeper@clipleap.com</a></p> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Intro'
}
</script>

<style lang="css" scoped>
.Intro {
  padding: 0 3rem;
  margin-bottom: 2rem;
  display: flex;
  justify-content: space-between;
}
.Intro>div {
  /* flex-basis: 100%; */
  /* width: 45%; */
}
h2 {
  margin-bottom: 1rem;
}
h3 {
  margin-bottom: 1rem;
}
.lead {
  margin-right: 1rem;
  flex-basis: 48%;
}

.in-progress {
  color: rgb(235, 228, 211);
  flex-basis: 48%;
}
.highlight {
  background-color: rgb(232, 162, 57);
  color: #000;
  padding: 0 0.5rem;
  /* margin-left: -0.5rem; */
}
</style>
